import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import templateProgress from "../../Assets/Images/templateProgress.webp";
import downloadLottie from "../../Assets/Animations/saveTemplateProgress.json";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/uploadImage.scss";
import LottiePlayer from "../LottiePlayer/lottiePlayer";

interface TemplateProgressProps {
  open: boolean;
  handleTemplate: () => void;
}

const TemplateProgress = ({ open, handleTemplate }: TemplateProgressProps) => {
  const [image, setImage] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    // setOpen(false)
    if (image && open) handleTemplate();
    return () => {
      setImage(false);
    };
  }, [image]);

  return (
    <Modal
      open={open}
      // onClose={() => {
      //   setOpen(false);
      // }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
        style: {
          backdropFilter: "blur(25px)",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <Fade in={open}>
        <Row className="model downloadProgressModal p-0 m-0">
          <Col className="d-flex flex-column justify-content-center align-items-center p-2 pb-0">
            <div className="position-relative w-100 p-1 pb-0">
              <img
                alt="progress"
                onLoad={() => setImage(true)}
                src={templateProgress}
                className="w-100 rounded roundedBottom_0"
              />
              <div className="downloadAnimation templateAnimation w_20">
                <LottiePlayer src={downloadLottie} />
              </div>
            </div>
            <Row className="productSansBold mt-5 text_23 mb-1">
              {t("SavingTemplate")}
            </Row>
            <Row className="productSansLight text_17 mb-5">
              {t("SavingTemplateDescription")}
            </Row>
          </Col>
        </Row>
      </Fade>
    </Modal>
  );
};

export default TemplateProgress;
